export default __webpack_public_path__ + "static/media/avatar-page.587821d0.svg";